<template>
  <div class="evidence">
    <div class="banner">
      <div class="area">
        <img src="../../assets/pre-registration/banner文字@2x.png" alt="">
        <div class="btn" @click="toEvidence">立即预登记</div>
      </div>
    </div>
    <div class="governance">
      <img src="../../assets/pre-registration/优势@2x.png" style="height: 38px; margin-top: 50px;" alt="">
      <div class="advantage">
        <div class="advantagey" v-for="item in btnList">
          <img :src="item.imgUrl" alt="">
          <p class="p1"> {{ item.label }} </p>
          <p class="p2"> {{ item.text }} </p>
        </div>
      </div>
    </div>
    <div class="flowpath blue">
      <img src="../../assets/pre-registration/登记材料准备@2x.png" alt="">
    </div>
    <div class="governance">
      <img src="../../assets/pre-registration/注册流程@2x.png"  style="height: 38px; margin-top: 50px;" alt="">
      
      <div class="process">
          <div class="adva">
              <div class="advantagey" >
                  <img src="../../assets/pre-registration/1@2x.png" alt="">
                  <p class="p1"> 1.登录时空社官网预登记 </p>
                  <p class="p2">https://www.wespace.cn</p>
              </div>
              <img class="imgurl" src="../../assets/pre-registration/箭头@2x.png" alt="">
              <div class="advantagey">
                  <img src="../../assets/pre-registration/2@2x.png" alt="">
                  <p class="p1"> 2.首都之窗账号注册，实名认证 </p>
                  <p class="p2">https://www.beijing.gov.cn</p>
              </div>
              <img class="imgurl" src="../../assets/pre-registration/箭头@2x.png" alt="">
              <div class="advantagey">
                  <img src="../../assets/pre-registration/3@2x.png" alt="">
                  <p  class="p1"> 3.登录首都之窗，进入作品自愿登记系统 </p>
                  <p  class="p2">https://banshi.beijing.gov.cn</p>
              </div>
              <img class="imgurl" src="../../assets/pre-registration/箭头@2x.png" alt="">
              <div class="advantagey">
                  <img src="../../assets/pre-registration/4@2x.png" alt="">
                  <p class="p1"> 4.等待版权局审核，通过后开通账户 </p>
                  <p class="p2">https://banshi.beijing.gov.cn</p>
              </div>
          </div>
          
      </div>
    </div>
    <div class="flowpath blue">
      <img src="../../assets/pre-registration/登记流程@2x.png" alt="">
    </div>
    <div class="questions white">
      <div class="area">
        <img class="title" src="../../assets/preservaTion/question.png" alt="">
        <div class="tablist">
          <p v-for="item in tablist" :key="item.problemList[0].id" @click="changeTab(item)" :class="activeTab === item.problemList[0].id?'active':''">{{item.type}}</p>
        </div>
        <div class="text">
          <h4>{{tagQuestion}}</h4>
          <p v-html="tagText"></p>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import { postProblem } from "@/api/index"
  export default {
    data(){
      return{
        activeBtn: '0',
        activeImg: require('../../assets/pre-registration/司法有效@2x.png'),
        btnList: [{
          code: '0',
          label: '司法有效',
          imgUrl: require('../../assets/pre-registration/司法有效@2x.png'),
          text:'实名认证登记，直通版权局，实现数据确权'
        },{
          code: '1',
          label: '高效便捷',
          imgUrl: require('../../assets/pre-registration/高效便捷@2x.png'),
          text:'专业版权经理辅导版权登记，提高版权登记效率'
        },{
          code: '2',
          label: '保护利益',
          imgUrl: require('../../assets/pre-registration/保护权益@2x.png'),
          text:'作品创作完成，可信版权链先存证，保障作品安全'
        },{
          code: '3',
          label: '溯源查证',
          imgUrl: require('../../assets/pre-registration/溯源查证@2x.png'),
          text:'双链存证，方便溯源查证，可靠易用'
        }],
        tagQuestion:'Q：版权局个人账户开通？',
        tagText: '北京互联网法院与北京版权保护中心共同搭建的“版权链-天平链行政司法协同治理平台”2.0版本，亮相2022年服贸会。版权链和天平链 实现了双标统一、双链协同、双驱促市三大功能。通过统一确权、授权、维权等环节存证的标准和规则，有效提升电子证据认定的效率和质量。“版权链”“天平链”对接，打通著作权登记信息与司法审判数据壁垒，实现版权登记信息实时交互、高效调取。',
        activeTab: 1,
        tablist:[
        //   {
        //   code: '0',
        //   label: '版权局个人账户开通',
        //   question: 'Q：版权局个人账户开通？',
        //   text: '北京互联网法院与北京版权保护中心共同搭建的“版权链-天平链行政司法协同治理平台”2.0版本，亮相2022年服贸会。版权链和天平链 实现了双标统一、双链协同、双驱促市三大功能。通过统一确权、授权、维权等环节存证的标准和规则，有效提升电子证据认定的效率和质量。“版权链”“天平链”对接，打通著作权登记信息与司法审判数据壁垒，实现版权登记信息实时交互、高效调取。'
        // },{
        //   code: '1',
        //   label: '版权局企业账户开通',
        //   question: 'Q：版权存证与登记区别？',
        //   text: '版权存证区别于版权登记，仅限于证明存证人在特定时间实施了作品文件电子存证行为，不用于证明作品权利归属。拥有准备材料少（核心是作品文件和权利人信息），下证审核时间更短、出证时间更快优点，可以作为版权登记的前置业务，是版权确权业务的一个重要补充'
        // },{
        //   code: '2',
        //   label: '版权预登记标准',
        //   question: 'Q：存证有效期？',
        //   text: '永久有效'
        // },{
        //   code: '3',
        //   label: '哪些作品可以进行预登记',
        //   question: 'Q：如何查证？',
        //   text: '<p>版权链和天平链实现了跨链对接，版权存证证书已接入北京市版权局和北京互联网法院的“版权链-天平链行政司法协同平台。</p> <p>版权链查证官网： https://www.licenseinfo.cn/</p> <p>北京互联网法院天平链查证链接： https://tpl.bjinternetcourt.gov.cn/index.html#/pcSearch</p>'
        // }
      ]
      }
    },
    created(){
      let userData = this.$store.state.userData
      sessionStorage.setItem('usnInfo', JSON.stringify(userData))
      sessionStorage.setItem('usn', userData.usn)
      this.postList()
    },
    methods:{
      toEvidence(){
          if (!sessionStorage.getItem('accessToken')) {
              this.$message({
                  message: '请先登录',
                  duration: 1000
              })
              this.$router.push({
                  path: '/login',
                  query: {
                    redirect: '/pre-registration'
                  }
              })
              return
          }else{
              this.$router.push({
                  path: '/copyright/home'
              })
              this.$parent.activeCode = '/pre-registration'
          }
      },
      postList(){
        postProblem().then((response) => {
          if(response.code == 200) {
            this.tablist = response.data
          }
        });
      },
      changeTab(item){
        console.log(item)
        this.activeTab = item.problemList[0].id
        this.tagQuestion = item.problemList[0].title
        this.tagText = item.problemList[0].contents
      },
      changeBtn(item){
        this.activeBtn = item.code
        this.activeImg = item.imgUrl
      }
    }
  }
</script>
  
<style lang="scss" scoped>
.governance{
  background-color: #FFF;
  text-align: center;
  padding-bottom: 90px;
  h2{
    // padding-top: 76px;
    padding-top: 76px;
    height: 38px;
    // font-size: 32px;
    font-size: 28px;
    font-family: PingFang SC-Medium, PingFang SC;
    font-weight: 600;
    color: #1D2129;
    line-height: 38px;
  }
  .process{
      background: url("../../assets/pre-registration/注册一览图@2x.png") no-repeat;
      background-size:100% 100%;
      margin: 0 auto;
      min-width: 1200px;
      max-width: 1200px;
      height: 400px;
      display: flex;
      .adva{
          margin-top: 145px;
          margin-left: 70px;
          width: 1035px;
          height: 230px;
          display: flex;
          .imgurl{
              margin-left: 10px;
              margin-right: 10px;
              margin-top: 70px;
              width: 45px;
              height: 30px;
          }
          .advantagey{
              //width: 192px;
              //height: 60px;

              // padding: 90px;
              //margin-right: 80px;
              img{
                width: 215px;
                height: 115px;
                margin-bottom: 10px;
              }
              .p1{
                //text-align: center;
                //margin-left: 10px;
                width: 215px;
                height: 28px;
                font-size: 15px;
                font-family: PingFang SC-Medium, PingFang SC;
                font-weight: 500;
                color: #1D2129;
                line-height: 28px;
              }
              .p2{
                margin-top: 21px;
                width: 215px;
                height: 66px;
                font-size: 14px;
                font-family: PingFang SC-Regular, PingFang SC;
                font-weight: 400;
                color: #3063F6;
                line-height: 22px;
      
              }
            }
      }
      
  }
  .advantage{
    display: flex;
    margin: 0 auto;
    min-width: 1200px;
    max-width: 1200px;
    padding-top: 75px;
    .advantagey{
      width: 430px;
      height: 260px;
      // padding: 90px;
      margin-right: 80px;
      img{
        width: 120px;
        height: 120px;
        margin-bottom: 10px;
      }
      .p1{
        text-align: center;
        margin-left: 10px;
        width: 198px;
        height: 28px;
        font-size: 22px;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 600;
        color: #1D2129;
        line-height: 28px;
      }
      .p2{
        margin-top: 21px;
        width: 228px;
        height: 66px;
        font-size: 14px;
        font-family: PingFang SC-Regular, PingFang SC;
        font-weight: 400;
        color: #9699AD;
        line-height: 22px;

      }
    }
  }
}
  .evidence{
    .banner{
      width: 100%;
      background: url("../../assets/pre-registration/banner@2x.png") no-repeat;
      background-size:100% 100%;
      .area{
      width: 1200px;
      max-width: 1200px;
      margin: 0 auto;
      padding-top: 6%;
      padding-bottom: 5%;
      img{
          width: 1200px;
          max-width: 1200px;
      }
      .btn{
        display: inline-block;
        padding: 0 28px;
        height: 48px;
        line-height: 48px;
        border-radius: 4px;
        background: #215AE5;
        color: #FFF;
        // font-weight: bold;
        font-size: 18px;
        cursor: pointer;
        margin-top: 42px;
        letter-spacing: 1px;
      }
    }
    }
    .blue{
      background: #F9FBFF;
    }
    .white{
      background: #FFF;
    }
    .card{
      text-align: center;
      padding-bottom: 58px;
      img{
        width: 1040px;
        transform: translateY(-40px);
      }
    }
    .number{
      text-align: center;
      padding-bottom: 98px;
      img{
        width: 920px;
      }
    }
    .about{
      padding: 98px 0;
      .area{
        position: relative;
        margin: 0 auto;
        width: 1044px;
        height: 500px;
        .btnArea{
          position: absolute;
          left: 38px;
          bottom: 38px;
          width: 168px;
          height: 314px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .btn{
            width: 168px;
            cursor: pointer;
            text-align: center;
            line-height: 50px;
            color: #1D2129;
            font-size: 16px;
            font-weight: bold;
            letter-spacing: 1px;
            border: 2px solid #FFFFFF;
            border-radius: 8px;
            background: rgba(57, 106, 255, 0.10);
            &.active{
              color: #FFF;
              background: linear-gradient(90deg, #4572FC 1%, #B5C7FF 99%);
            }
          }
        }
        .imgArea{
          width: 694px;
          position: absolute;
          right: 38px;
          bottom: 38px;
          img{
            width: 100%;
          }
        }
      }
    }
    .flowpath{
      padding: 98px 0;
      text-align: center;
      img{
        width: 1040px;
        height: auto;
      }
    }
    .questions{
      padding: 80px 0;
      .area{
        width: 1040px;
        margin: 0 auto;
        text-align: center;
        .title{
          width: 108px;
          margin-bottom: 68px;
        }
        .tablist{
          display: flex;
          border-bottom: 1px solid #D5E2FC;
          margin-bottom: 48px;
          p{
            flex: 1;
            cursor: pointer;
            text-align: center;
            line-height: 46px;
            font-size: 16px;
            color: #1D2129;
            &.active{
              background: linear-gradient(270deg, #3C6FEA 3%, #7E9FF1 100%);
              color: #fff;
            }
          }
        }
        .text{
          padding: 48px;
          width: 100%;
          height: 264px;
          background: url('../../assets/preservaTion/questionbg.png') no-repeat;
          background-size: 100% 100%;
          text-align: left;
          h4{
            color: #1D2129;
            font-weight: bold;
            font-size: 16px;
          }
          p{
            font-size: 14px;
            margin-top: 16px;
            width: 586px;
            margin-left: 28px;
            line-height: 26px;
          }
        }
      }
    }
  }
  </style>